import { type ProductData } from "~/domains/product/types/ProductData";
import Modal from "~/common/components/Modal";
import { HousingTabularViewDetailPanel } from "~/features/selectionAssistant/housing/components/VariantProductsTableModal/HousingTabularViewDetailPanel";
import { Box } from "~/common/mui";

interface Props {
  onClose: () => void;
  products: ProductData[];
}

export const VariantProductsTableModal = (props: Props) => {
  return (
    <Modal onClose={props.onClose}>
      <Box
        sx={{
          width: "calc(100% - 48px)",
          marginLeft: "24px",
          marginRight: "24px",
          paddingLeft: "16px",
          paddingRight: "16px",
          zIndex: 1200,
        }}
      >
        <HousingTabularViewDetailPanel products={props.products} />
      </Box>
    </Modal>
  );
};;
